import { render } from "./C403Error.vue?vue&type=template&id=b557722a&scoped=true"
const script = {}

import "./C403Error.vue?vue&type=style&index=0&id=b557722a&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b557722a"]])

export default __exports__